import React from 'react';
import './noResultsCard.scss';

const NoResultsCard = ({ copy }) => {
    return (
        <div className='no-results-card'>
            <h2 id='heading'>{copy}</h2>
            <p>Try changing your filters.</p>
        </div>
    );
};

export default NoResultsCard;